type Architecture = {
  business_backend: "local" | "local_product" | "cloud";
  business_api_prefix: "" | "/sales-cloud";
};
const roots = [
  "/v2/projects",
  "/v2/keyword-groups",
  "/v2/message-groups",
  "/v2/task-keyword-group",
  "/v2/task-message-group",
  "/v2/keyword-history",
  "/v2/ai-assistant",
  "/v2/reply-todos",
  "/v2/wechat-friends",
  "/leads",
  "/leads-summary",
  "/lead-source-batches",
  "/lead-sources",
  "/saved-lead-views",
  "/target-batches",
  "/v2/target-batches",
  "/contact-lists",
  "/templates",
  "/search-terms",
  "/social-searches",
  "/social-leads",
  "/blogger-intelligence",
  "/agent-search",
  "/agent-search-batches",
  "/credits",
  "/agent-runs",
  "/work-records",
  "/settings/social-categories",
  "/v2/queue-task-config",
  "/v2/overview-metrics",
  "/notifications",
  "/device-queues",
  "/settings/runtime",
  "/task-catalog",
  "/task-resource-catalog",
  "/queue-task-catalog",
  "/inbox-observations",
];
let architecture: Promise<Architecture> | undefined;
export function resetBusinessRouting() {
  architecture = undefined;
}
export async function businessPath(path: string): Promise<string> {
  const pathname = path.split("?")[0];
  const queueMode =
    /^\/v2\/devices\/[^/]+\/(queue-mode|queue-control|patrol-schedules(?:\/[^/]+)?)$/.test(
      pathname,
    );
  if (
    !queueMode &&
    !roots.some((root) => pathname === root || pathname.startsWith(root + "/"))
  )
    return path;
  if (!architecture)
    architecture = (async () => {
      const response = await fetch("/api/client-architecture", {
        cache: "no-store",
        signal: AbortSignal.timeout(10_000),
      });
      if (!response.ok)
        throw new Error(
          "无法确认业务服务器，请检查连接后重试；不会读取本地旧资料。",
        );
      let data: Architecture;
      try {
        data = await response.json();
      } catch {
        throw new Error("服务版本不匹配，请重启本机服务后重试。");
      }
      const valid =
        data?.business_backend === "cloud" ||
        data?.business_backend === "local_product"
          ? data.business_api_prefix === "/sales-cloud"
          : data?.business_backend === "local" &&
            data.business_api_prefix === "";
      if (!valid) throw new Error("服务版本不匹配，请重启本机服务后重试。");
      return data;
    })().catch((error) => {
      architecture = undefined;
      throw error;
    });
  const selected = await architecture;
  if (
    selected.business_backend === "local" &&
    (pathname === "/work-records" || pathname.startsWith("/work-records/"))
  )
    return path.replace("/work-records", "/tasks");
  return selected.business_api_prefix + path;
}
